/**
 * External dependencies
 */
export default class WeblinkGroup {
    constructor(cscom) {
        if (!(this instanceof WeblinkGroup)) {
            return new WeblinkGroup(cscom);
        }
        this.cscom = cscom;
    }

    getWeblinkGroups() {
        return this.cscom.req.get('/user-site-api/weblink-groups');
    }

    testWeblinkGroup() {
        return this.cscom.req.get('/user-site-api/test-user-ftp');
    }
}
